export default __webpack_public_path__ + "static/media/FirstSupervisionMap.0a3342ec.mrt";